import { Component, Inject, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { IDialogData } from "../../viewer-components/interfaces/i-dialog-data";
import { MultiExportGeotiffDialog } from "./multi-export-geotiff-dialog";

@Component({
  selector: "phoenix-multi-export-geotiff-dialog",
  templateUrl: "./multi-export-geotiff-dialog.html",
  styleUrls: ["./multi-export-geotiff-dialog.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class PhoenixMultiExportGeotiffDialog extends MultiExportGeotiffDialog {
  constructor(
    dialogRef: MatDialogRef<MultiExportGeotiffDialog>,
    @Inject(MAT_DIALOG_DATA) public data: IDialogData,
  ) {
    super(dialogRef, data);
  }
}
